"use client"

import { Button } from "@/components/atoms"
import { Modal } from "@/components/molecules"
import { useState } from "react"
import { HttpTypes } from "@medusajs/types"
import { SellerProps } from "@/types/seller"
import { MessageDotsRound } from "@/icons"
import ChatWidget from "./ChatWidget"
import { useTranslate } from "@tolgee/react"

export const Chat = ({
  children,
  user,
  seller,
  buttonClassNames,
  className,
  icon,
  product,
  subject,
  order_id,
}: {
  children?: React.ReactNode
  user: HttpTypes.StoreCustomer | null
  seller: SellerProps
  buttonClassNames?: string
  className?: string
  icon?: boolean
  product?: HttpTypes.StoreProduct
  subject?: string
  order_id?: string
}) => {
  const { t } = useTranslate()
  const [modal, setModal] = useState(false)

  return (
    <>
      <Button
        variant="tonal"
        onClick={() => setModal(true)}
        className={className || buttonClassNames}
      >
        {children ? (
          children
        ) : icon ? (
          <MessageDotsRound size={30} />
        ) : (
          t("chat.chat_with_seller")
        )}
      </Button>
      {/* 仅在打开时挂载 ChatWidget，避免与 ChatProvider 后台实例并发登录 */}
      {modal ? (
        <Modal heading="Chat" onClose={() => setModal(false)}>
          <div className="px-4 min-h-[400px]">
            <ChatWidget
              order_id={order_id}
              product={product}
              customer={user}
              seller={seller}
              chatPerProduct={!!product}
            />
          </div>
        </Modal>
      ) : null}
    </>
  )
}
